module.exports = __webpack_public_path__ + "static/Dental implants intraoral after-2a6ffd585b32145cdb4ec25f2748f6c8.jpg";